import { cva } from 'class-variance-authority';

export const containerVariants = cva(
  'group h-full relative flex bg-white border-gray-200 border md:border md:rounded-md overflow-hidden',
  {
    variants: {
      imagePosition: {
        left: 'flex-col md:!flex-row',
        top: '!rounded-md !flex-col',
      },
      layout: {
        default: 'flex-col md:flex-row rounded-md',
        halfImage: '',
        noImage:
          'flex-col !border-x-[transparent] !border-t-[transparent] !rounded-none md:!rounded-md md:!border-x-gray-300 md:!border-t-gray-300',
        noImageMobile:
          'flex-col !border-x-[transparent] !border-t-[transparent] !rounded-none md:!rounded-md md:!border-x-gray-300 md:!border-t-gray-300',
      },
    },
    defaultVariants: {
      imagePosition: 'left',
      layout: 'default',
    },
  }
);

export const imageContainerVariants = cva(
  'block rounded-t-md md:rounded-none overflow-hidden relative min-h-[120px] bg-gray-200 animate-pulse',
  {
    variants: {
      imagePosition: {
        left: 'md:basis-[30%] min-w-[150px]',
        top: 'md:min-h-[200px]',
      },
      layout: {
        default: '',
        halfImage: 'md:!h-[calc(50%-14px)] md:!min-h-[calc(50%-14px)]',
        noImage: 'hidden',
        noImageMobile: 'hidden md:block',
      },
    },
    defaultVariants: {
      imagePosition: 'left',
      layout: 'default',
    },
  }
);

export const contentContainerVariants = cva('w-auto h-[inherit] p-4 py-2 pb-3 md:flex md:flex-col', {
  variants: {
    layout: {
      default: 'md:basis-[70%]',
      halfImage: '',
      noImage: '!basis-full',
      noImageMobile: 'basis-full md:basis-[70%]',
    },
  },
  defaultVariants: {
    layout: 'default',
  },
});
